export const SET_COMPANIES = 'SET_COMPANIES'
export const SAVE_COMPANY = 'SAVE_COMPANY'
export const UPDATE_COMPANY_STOR = 'UPDATE_COMPANY_STORE'
export const DOWNLOAD = 'DOWNLOAD'
export const UPLOAD = 'UPLOAD'
export const CHANGE_FILTER = 'CHANGE_FILTER'
export const SET_IS_LOADING = 'SET_IS_LOADING'
export const SET_SPOT_TO_EDIT = 'SET_SPOT_TO_EDIT'
export const SET_NEWS_TO_EDIT = 'SET_NEWS_TO_EDIT'
export const SET_BLOG_TO_EDIT = 'SET_BLOG_TO_EDIT'
export const GET_SPOT_TO_EDIT = 'GET_SPOT_TO_EDIT'
export const GET_NEWS_TO_EDIT = 'GET_NEWS_TO_EDIT'
export const SET_USER = 'SET_USER'
export const TOKEN_AUTH = 'TOKEN_AUTH'
export const UPDATE_SPOT_DATABASE = 'UPDATE_SPOT_DATABASE'
export const GET_NEWS = 'GET_NEWS'
export const SET_NEWS = 'SET_NEWS'
export const SAVE_CATEGORIES = 'SAVE_CATEGORIES'
export const GET_CATEGORY_TEXT = 'GET_CATEGORY_TEXT'
export const SET_CATEGORY_TO_EDIT = 'SET_CATEGORY_TO_EDIT'
export const GET_CATEGORY_TO_EDIT = 'GET_CATEGORY_TO_EDIT'
export const RESET_ACTIVE_TYPE = 'RESET_ACTIVE_TYPE'
export const SAVE_PREMIUM_PLAN =  'SAVE_PREMIUM_PLAN'
export const SET_PREMIUM_PLAN_TO_EDIT = 'SET_PREMIUM_PLAN_TO_EDIT'
export const GET_PREMIUM_PLAN_TO_EDIT = 'GET_PREMIUM_PLAN_TO_EDIT'